import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import FormError from '../common/FormError';
import FormContainer from '../common/FormContainer';
import LoginFormForm from './LoginFormForm';
import { useTranslation } from 'react-i18next';

function LoginForm(props) {
  const { t } = useTranslation();
  const { username, setUsername, password, setPassword, step, onEmailSubmit, onFormSubmit, onBack, isSubmitting, formError } = props;

  return (
    <FormContainer>
      <Paper square sx={{ p: 3, width: 425 }}>
        <FormError formError={ formError }/>
        <LoginFormForm
          username={ username }
          setUsername={ setUsername }
          password={ password }
          setPassword={ setPassword }
          step={ step }
          onEmailSubmit={ onEmailSubmit }
          onFormSubmit={ onFormSubmit }
          onBack={ onBack }
          isSubmitting={ isSubmitting }
        />
      </Paper>
      <Link
        to="/forgot-password"
        component={ RouterLink }
        underline="hover"
        sx={{
          mt: 1
        }}
      >
        {t('auth.login.forgotPassword')}
      </Link>
    </FormContainer>
  );
}

export default LoginForm;
